import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { NotificationProvider } from './context/NotificationContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import AdminLayout from './components/AdminLayout';
import FloatingCartButton from './components/FloatingCartButton';
import MobileBottomNav from './components/MobileBottomNav';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import OrdersPage from './pages/OrdersPage';
import ProfilePage from './pages/ProfilePage';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProductManagement from './pages/admin/ProductManagement';
import AdminProducts from './pages/admin/AdminProducts';
import AdminProductForm from './pages/admin/AdminProductForm';
import AdminOrders from './pages/admin/AdminOrders';
import ManagementPage from './pages/admin/ManagementPage';
import UserManagement from './pages/admin/UserManagement';

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <NotificationProvider>
          <ScrollToTop />
          <FloatingCartButton />
          <MobileBottomNav />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <HomePage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/products" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <ProductsPage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/product/:id" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <ProductDetailPage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/cart" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <CartPage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/checkout" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <CheckoutPage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/login" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <LoginPage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/register" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <RegisterPage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/orders" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <OrdersPage />
                </main>
                <Footer />
              </div>
            } />
            <Route path="/profile" element={
              <div className="flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow bg-gray-50 pb-16 md:pb-0">
                  <ProfilePage />
                </main>
                <Footer />
              </div>
            } />

            {/* Admin Login Route */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
            <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
            <Route path="/admin/products" element={<AdminLayout><ProductManagement /></AdminLayout>} />
            <Route path="/admin/products/old" element={<AdminLayout><AdminProducts /></AdminLayout>} />
            <Route path="/admin/products/add" element={<AdminLayout><AdminProductForm /></AdminLayout>} />
            <Route path="/admin/products/edit/:id" element={<AdminLayout><AdminProductForm /></AdminLayout>} />
            <Route path="/admin/orders" element={<AdminLayout><AdminOrders /></AdminLayout>} />
            <Route path="/admin/management" element={<AdminLayout><ManagementPage /></AdminLayout>} />
            <Route path="/admin/users" element={<AdminLayout><UserManagement /></AdminLayout>} />
          </Routes>
          </NotificationProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
